import { HoruzError } from '../../../../errors/error.js';
import { HoruzProtocolChulakCloseCode } from '../../codes.js';

/**
 * Error
 * @public
 */
export class HoruzProtocolChulakErrorProtocolUnknown extends HoruzError {
  constructor(reason?: string) {
    super(HoruzProtocolChulakCloseCode.PROTOCOL_UNKNOWN_ERROR, reason);
  }
  /**
   * Constructs error
   * @param reason Reason
   * @returns Error
   */
  static Create(reason?: string) {
    return new this(reason);
  }
}
